export var RatingType;
(function (RatingType) {
    RatingType[RatingType["ALL"] = 0] = "ALL";
    RatingType[RatingType["NEGATIVE"] = 10] = "NEGATIVE";
    RatingType[RatingType["POSITIVE"] = 20] = "POSITIVE";
})(RatingType || (RatingType = {}));
;
//# sourceMappingURL=rating-type.enum.js.map